import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core'
import { EditBase, Button } from 'react-admin'
import CloseIcon from '@mui/icons-material/Close'

export const DialogForm = ({
  id,
  title,
  open = false,
  showButtonProps = {},
  onSuccess,
  children,
  transform = (data) => data,
}) => {
  const [showEditDialog, setShowEditDialog] = useState()

  useEffect(() => {
    setShowEditDialog(open)
  }, open)

  const showButton = (
    <Button
      color="secondary"
      variant="contained"
      onClick={(event) => {
        event.stopPropagation()
        setShowEditDialog(true)
      }}
      label="ra.action.edit"
      {...showButtonProps}
    />
  )

  return (
    <>
      <Dialog
        fullWidth
        // maxWidth="md"
        open={showEditDialog}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <DialogTitle sx={{ padding: '16px 24px 0 24px' }}>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={() => setShowEditDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <EditBase
          id={id}
          mutationMode="pessimistic"
          resource={children.props.resource}
          basePath={children.props.basePath}
          redirect={false}
          mutationOptions={{
            onSuccess: () => {
              setShowEditDialog(false)
              if (onSuccess) onSuccess()
            },
          }}
          transform={transform}
        >
          {children}
        </EditBase>
      </Dialog>
      {showButton}
    </>
  )
}
